<script>
  import Options from "./Options.svelte"
  import Table from "./Table.svelte"

  export let dataset
  let currentPage = 1
  let selectedSector = ""
  let selectedSubsector = ""
  let selectedResourceType = ""
  let selectedState = ""
  let searchText
  $: row = { isOpen: false }

  $: totalEntries = filteredData().length

  $: filteredData = () => {
    return dataset.data
      .filter((row) => {
        const rowDate = new Date(row.date_string)

        const isSelectedState = selectedState
          ? row.states.includes(selectedState)
          : true
        const isSelectedSector = selectedSector
          ? row.sectors.includes(selectedSector)
          : true
        const isSelectedSubsector = selectedSubsector
          ? row.subsectors.includes(selectedSubsector)
          : true
        const isSelectedResourceType = selectedResourceType
          ? row.type === selectedResourceType
          : true

        const filteredTimelineEvent = searchText
          ? searchText.toLowerCase().trim()
          : ""

        const matchesText = (texts) => {
          return Array.isArray(texts)
            ? texts.some((text) =>
                text.toLowerCase().includes(filteredTimelineEvent)
              )
            : texts.toLowerCase().includes(filteredTimelineEvent)
        }

        const matchesAnyCondition = [
          matchesText(row.timelineEvent.headline),
          matchesText(row.sectors),
          matchesText(row.subsectors),
          matchesText(row.type),
        ].some(Boolean)

        return (
          matchesAnyCondition &&
          isSelectedSector &&
          isSelectedSubsector &&
          isSelectedResourceType &&
          isSelectedState
        )
      }).sort((a, b) => {
      // Manually parse the date strings into components
      const [monthA, dayA, yearA] = a.date_string.split('/').map(Number);
      const [monthB, dayB, yearB] = b.date_string.split('/').map(Number);

      // Compare years first
      if (yearA !== yearB) {
        return yearB - yearA; // For descending order
      }

      // If years are the same, compare months
      if (monthA !== monthB) {
        return monthB - monthA; // For descending order
      }

      // If both year and month are the same, compare days (optional)
      return dayB - dayA; // For descending order
    });
  }
</script>

<div id="site-content">
  <section class="table-container">
    <Options
      {dataset}
      bind:currentPage
      {totalEntries}
      bind:row
      bind:selectedSector
      bind:selectedSubsector
      bind:selectedState
      bind:selectedResourceType
      bind:searchText
    />
    <Table bind:currentPage {dataset} filteredData={filteredData()} bind:row />
  </section>
</div>

<style lang="scss">
  @use "../scss/components/table-container";
</style>
